module.exports = __webpack_public_path__ + "img/ios.ab2b71a0.png";